'use client';

import { motion, useReducedMotion } from 'framer-motion';

export function AmbientGlow() {
  const reduceMotion = useReducedMotion();

  return (
    <div
      className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
      aria-hidden
    >
      <motion.div
        className="bg-surface-brand absolute top-[-140px] left-1/2 h-[540px] w-[900px] rounded-full blur-3xl"
        initial={{ x: '-50%' }}
        animate={
          reduceMotion
            ? { x: '-50%' }
            : {
                x: ['-50%', '-42%', '-58%', '-50%'],
                y: [0, 36, -20, 0],
                scale: [1, 1.1, 0.94, 1],
              }
        }
        transition={{
          duration: 22,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="bg-surface-brand absolute top-[20px] left-1/2 h-[340px] w-[560px] rounded-full opacity-70 blur-3xl"
        initial={{ x: '-35%' }}
        animate={
          reduceMotion
            ? { x: '-35%' }
            : {
                x: ['-35%', '-58%', '-22%', '-35%'],
                y: [0, -28, 32, 0],
                scale: [1, 0.9, 1.12, 1],
              }
        }
        transition={{
          duration: 28,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  );
}
